<form [formGroup]="pairingForm">
   <select formControlName="ladderId">
      <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.ladderId}} - {{l.name}}</option>
   </select>
   <br />
   <select formControlName="levelId">
      <option *ngFor="let l of levels" [ngValue]="l.id">{{l.id}} - {{l.nameLong}}</option>
   </select>
   <br />


   <br />

   <table>
      <tr>
         <td width="50%">
            <div formArrayName="players">
               <div *ngFor="let _ of players.controls; let i=index">
                  <!-- <div [formGroupName]="players"> -->
                  <input type="text" style="width: 400px;" placeholder="ranked {{i}}" [formControlName]="i" />
                  <!-- </div> -->

               </div>
            </div>
         </td>
         <td>
            <table class="playerlist" border="1" cellpadding="3">
               <tbody>
                  <tr *ngFor="let s of playerScoreResp">
                     <td>{{s.opponent.id}}</td>
                     <td>{{s.opponent.name}}</td>
                     <td>{{s.points}}</td>
                  </tr>
               </tbody>
            </table>
         </td>
      </tr>
   </table>


   <i>be sure to change the 000000 player to match the level!</i>
   <br />
   <button (click)="doit($event)">do it</button>
</form>
<hr />
{{playerScoreResp|json}}
<hr />

<div *ngIf="result" style="margin-top: 20px;">
   {{result|json}}
</div>